import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { DatabaseService } from './database.service';
import { MotesPaths, PageMeta } from '../models';
import { Observable } from 'rxjs';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class PageMetaService {

    private readonly defaultImage = 'https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Fbackgrounds%2FConceptImage-New.png?alt=media&token=75dcc502-f943-4b63-8311-c54aec1f47b2';

    constructor(
        private af: DatabaseService,
        private titleService: Title,
        private metaService: Meta,
        private router: Router,
        @Inject(LOCALE_ID) public locale: string) {
    }

    public init() {
    }

    public watchMetaData(pageKey: string): Observable<PageMeta> {
        return this.af.object<PageMeta>(MotesPaths.PAGE_META_DB_PATH(pageKey)).valueChanges();
    }

    public saveMetaData(pageKey: string, pageMeta: PageMeta) {
        if(!pageKey) return console.error("Could not save page meta, empty page key.");
        return this.af.object(MotesPaths.PAGE_META_DB_PATH(pageKey)).set(pageMeta);
    }

    /**
     * Add or update meta tags in index.html
     * Requirements for image url (in order to show on most important platforms):
     * 1) Not .webp
     * 2) Min 1200px (width) and 627px (height)
     * 3) Max file size: 5 MB
     */
    public setPageMeta(pageMeta: PageMeta, imageUrl?: string) {
        if(!pageMeta) return console.warn("No page meta found for this page, skipping");

        this.titleService.setTitle("StoryHunt - " + pageMeta.title);
        let url = (`${MotesPaths.MOTES_HOME}/${this.locale}${this.router.url}`);

        let tags: MetaDefinition[] = [
            { name: 'title', content: `StoryHunt - ${pageMeta.title}` },
            { name: 'keywords', content: pageMeta.keywords },
            { name: 'description', content: pageMeta.description },
            { name: 'robots', content: pageMeta.published ? 'index, follow' : 'noindex, nofollow' },
        ];

        let ogTags: MetaDefinition[] = [
            { property: 'og:title', content: `StoryHunt - ${pageMeta.title}` },
            { property: 'og:description', content: pageMeta.description },
            { property: 'og:image', content: imageUrl || this.defaultImage },
            { property: 'og:url', content: url }
        ];

        tags.forEach((tag) => this.metaService.updateTag(tag, tag.name));
        ogTags.forEach((tag) => this.metaService.updateTag(tag, `property='${tag.property}'`));
    }
}
